<template>
  <div class="order-layout">
    <navbar layout="profile"></navbar>
    <main class="order-layout__main">
    <PromoPlan></PromoPlan>
    <section class="order-section order-layout__content">
      <router-view></router-view>
    </section>
      <RegulationFooterLink class="order-layout__footer" />
    </main>
  </div>
</template>

<script>
import Navbar from "../components/Navbar";
import RegulationFooterLink from "~/components/Common/RegulationFooterLink.vue";

export default {
  components: {
    Navbar,
    RegulationFooterLink
  },
  created: function() {
    this.$store.dispatch("user/fetchUser");
    this.$store.dispatch("counterparty/fetchCounterparties");
  }
};
</script>

<style scoped lang="scss">
.order-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.order-layout__main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.order-layout__content {
  flex: 1;
  min-height: 0;
}

.order-layout__footer {
  flex-shrink: 0;
}
</style>
